exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qc-review .el-table .file[data-v-4c3eb07b]{cursor:pointer;color:#ff8850;text-decoration:underline}\n", ""]);

// exports
